function initList() {

    let value = $('.locationFilter').val(), shopList = $(".shop-list");
    shopList.show();
    shopList.css("opacity","0.25");
    $.get("/wp-json/shamrock/v1/shop/listByState/"+value, function(data){
       shopList.find(".retailers-list").html("<li>"+data.join("</li><li>")+"</li>");
    }).always(function(){
        shopList.css("opacity","1");
    });

}

export function whereToBuyList() {
    
    initList();

    
    $(document).on('change', '.locationFilter', function() {
        initList();    
    });
}
